/**
 * The purpose of this Utility class is to help with time issues
 * Anything that realies on the timming of ceritan things, race conditions and such
 */

/**
 * Calls Wait Function until it returns true, then it will call the main function.
 * Primary used for handling race conditions
 * @param {Function} waitFunction this will EVENTUALLY return true, we are just waiting
 * @param {Function} mainFunction This is the function that you want to call, given the wait Function
 * @param {Number} time this is the time between each loop of the Event Loop
 */
export const waitForRaceCondition = function (waitFunction, mainFunction, time = 100) {
  if (waitFunction()) {
    mainFunction()
  } else {
    setTimeout(() => { waitForRaceCondition(waitFunction, mainFunction, time) }, time)
  }
}



// WEBPACK FOOTER //
// ./src/app/common/U_T.js